import { employerAccountingApiV1 } from "./client";

export const getCurrentUserBalance = async(): Promise<number> => {
  return (await employerAccountingApiV1.balance.balance()).data.balance;
};
